import { redirect, createFileRoute } from '@tanstack/react-router'
import { getPlayerSession } from '@/features/player-session'

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return redirect({ to: '/' })
    }

    await playerSession.login({ doesCurrentHrefRequiresAuth: false })
  },
})
